/* eslint-disable no-plusplus */
import { useState, useEffect, useCallback } from 'react';
var CURRENT_YEAR = new Date().getFullYear();
var RANGE_YEARS = 11;
export var useYearRange = function (initialYear) {
    if (initialYear === void 0) { initialYear = CURRENT_YEAR; }
    var _a = useState([]), yearRange = _a[0], setYearRange = _a[1];
    var generateFirstYears = useCallback(function () {
        var tmp = [initialYear];
        if (!yearRange.length) {
            for (var i = 0; i < RANGE_YEARS; i++) {
                tmp.push(tmp[tmp.length - 1] + 1);
            }
            setYearRange(tmp);
        }
    }, [initialYear, yearRange.length]);
    useEffect(generateFirstYears, [generateFirstYears]);
    var prevYears = function () {
        var tmp = [yearRange[0] - 1];
        for (var i = 0; i < RANGE_YEARS; i++) {
            tmp.unshift(tmp[0] - 1);
        }
        setYearRange(tmp);
    };
    var nextYears = function () {
        var tmp = [yearRange[yearRange.length - 1] + 1];
        for (var i = 0; i < RANGE_YEARS; i++) {
            tmp.push(tmp[tmp.length - 1] + 1);
        }
        setYearRange(tmp);
    };
    return {
        yearRange: yearRange,
        prevYears: prevYears,
        nextYears: nextYears,
        titleRange: "".concat(yearRange[0], " - ").concat(yearRange[yearRange.length - 1]),
    };
};
